export default __webpack_public_path__ + "7592664d76ed4d6a8d1586ccb3c36178.svg";